import React from 'react';
import { View, StyleSheet, Text } from 'react-native';

import { InstallmentPlan } from 'apollo/queries/autogenerate/schemas';
import { AMZ_SUB_MERCHANTS_IDS } from 'shared/constants/amazon';
import Icon from 'shared/modules/common/components/atoms/Icon';
import { formatYen } from 'shared/modules/usage/utils/utils';
import { isAmazonStoreName } from 'shared/utils/amazon-pay-default-storename';

type ListItemProps = {
  installment: InstallmentPlan;
  date: string;
  amount: number;
  description: string | null | JSX.Element;
  installmentBreakdown: string;
};

const InstallmentItem = (props: ListItemProps) => {
  const payment = props.installment.payment;

  const isAmazonPay =
    payment?.subMerchantId === AMZ_SUB_MERCHANTS_IDS.amazonPay;

  // If the storeName of Amazon Pay purchase starts with 'AMZ', should display default title
  const shouldConvertAmazonPayDefaultTitle =
    !!payment?.storeName && isAmazonStoreName(payment?.storeName);

  // If the the payment is Amazon Pay purchase, should display following title
  const amazonPayTitle = isAmazonPay
    ? payment?.storeName === null ||
      payment?.storeName === '<NO NAME>' ||
      payment?.storeName === undefined ||
      shouldConvertAmazonPayDefaultTitle
      ? 'Amazon Pay提携サイト'
      : payment?.storeName
    : null;

  // If the payment is Amazon Purchase besides Amazon Pay and the storeName is null, should display the default value 'Amazon.co.jp'
  const isAmazon =
    payment?.subMerchantId === AMZ_SUB_MERCHANTS_IDS.amazonPrime ||
    AMZ_SUB_MERCHANTS_IDS.amazonKindle ||
    AMZ_SUB_MERCHANTS_IDS.amazonMusic ||
    AMZ_SUB_MERCHANTS_IDS.amazonPharmacy ||
    AMZ_SUB_MERCHANTS_IDS.amazonPrimeVideo ||
    AMZ_SUB_MERCHANTS_IDS.amazonRetail ||
    AMZ_SUB_MERCHANTS_IDS.amazonMarketplace;

  const amazonTitle = isAmazon
    ? payment?.storeName === null || payment?.storeName === '<NO NAME>'
      ? 'Amazon.co.jp'
      : payment?.storeName
    : null;
  const title = amazonPayTitle ?? amazonTitle ?? payment?.storeName;

  return (
    <View style={styles.container}>
      <Icon name="npay" size="24" style={styles.icon} />

      <View style={styles.middle}>
        {title && (
          <Text style={styles.text} numberOfLines={3}>
            {title}
          </Text>
        )}
        {!!props.date && <Text style={styles.subText}>{props.date}</Text>}
        {!!props.installmentBreakdown && (
          <Text style={styles.subText}>{props.installmentBreakdown}</Text>
        )}
        {!!props.description && (
          <Text style={styles.subText}>{props.description}</Text>
        )}
      </View>

      <View style={styles.right}>
        <Text style={styles.text}>{formatYen(props.amount)}</Text>
      </View>
    </View>
  );
};

export default InstallmentItem;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center',
    margin: 16,
  },
  icon: {
    marginRight: 16,
    alignSelf: 'flex-start',
  },
  middle: {
    flex: 1,
  },
  right: {
    alignItems: 'flex-end',
  },
  text: {
    fontSize: 12,
    fontWeight: 'bold',
    lineHeight: 16,
    color: '#2a2e32',
  },
  subText: {
    fontSize: 12,
    fontWeight: '300',
    lineHeight: 16,
    color: '#4c525b',
    marginTop: 8,
  },
});
